import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaAngleRight } from "react-icons/fa";
import "./EnquiryBoard.css";
import { Box, Typography } from "@mui/material";
import translations from "../../../assets/locals/translations";

// moved inside component so translations can be applied via `t`

const EnquiryBoard = () => {
  const navigate = useNavigate();

  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations["en"];

  const enquiryTypes = [
    {
      label: t.new || "New",
      type: "NEW",
      color: "#28A745",
      description: t.new_description || "Manage fresh enquiries promptly.",
    },
    {
      label: t.hot || "Hot",
      type: "HOT",
      color: "#FF6B6B",
      description: t.hot_description || "Focus on high-priority, urgent leads.",
    },
    {
      label: t.cold || "Cold",
      type: "COLD",
      color: "#4A90E2",
      description: t.cold_description || "Review lower-priority or dormant enquiries.",
    },
    {
      label: t.warm || "Warm",
      type: "WARM",
      color: "#FF9800",
      description: t.warm_description || "Engage with moderately interested prospects.",
    },
  ];

  const formatType = (type) => type.toLowerCase();

  const handleNavigation = (type) => {
    const formattedType = formatType(type);
    navigate(`/sale/enquiries/${formattedType}`, { state: { type } });
  };

  return (
    <div className="enquiry-board-wrapper bg-white">
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold", mr: 2 }}>
          {t.enquiryDashboard || "Enquiry Dashboard"}
        </Typography>
        <Box sx={{ flexGrow: 1, borderBottom: "1px solid #ccc" }} />
      </Box>
      <div className="enquiry-sections">
        {enquiryTypes.map(({ label, type, color, description }, index) => (
          <div
            key={index}
            className="enquiry-card"
            style={{ borderLeft: `4px solid ${color}` }}
            onClick={() => handleNavigation(type)}
          >
            <div className="enquiry-card-content">
              <div className="enquiry-text">
                <h3 className="enquiry-label" style={{ color }}>
                  {label}
                </h3>
                <p className="enquiry-description">{description}</p>
              </div>
              <span className="enquiry-icon" style={{ color }}>
                <FaAngleRight />
              </span>
            </div>
          </div>
        ))}
      </div>
      <Box sx={{ flexGrow: 1, borderBottom: "1px solid #ccc", marginY: 2 }} />
      <div className="enquiry-old-section">
        <div
          className="enquiry-card old"
          onClick={() => handleNavigation("OLD")}
          style={{ borderLeft: "4px solid #1976d2" }}
        >
          <div className="enquiry-card-content">
            <div className="enquiry-text">
              <h3 className="enquiry-label" style={{ color: "#1976d2" }}>
                {t.old_tractor_enquiry || "Old Tractor Enquiry"}
              </h3>
              <p className="enquiry-description">
                {t.old_tractor_description || "Review old tractor enquiries."}
              </p>
            </div>
            <span className="enquiry-icon" style={{ color: "#1976d2" }}>
              <FaAngleRight />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnquiryBoard;
